var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var SearchResultsList = require('./SearchResultsList');
var CoachSearchForm = require('./CoachSearchForm');
var SearchResultMessage = require('./SearchResultMessage');

var keywordsQsFieldName = 'cs_q',
	locationQsFieldName = 'cs_loc',
	distanceQsFieldName = 'cs_d',
	distanceUnitsQsFieldName = 'cs_du',
	sportTypesQsFieldName = 'cs_st',
	servicesQsFieldName = 'cs_s',
	languagesQsFieldName = 'cs_l',
	abilityLevelsQsFieldName = 'cs_al',
	gendersQsFieldName = 'cs_g',
	trainingPeaksCertificationsQsFieldName = 'cs_tc',
	latQsFieldName = 'cs_lat',
	lngQsFieldName = 'cs_lng';

var CoachSearchComponent = createReactClass({
	getConfig: function() {
		return coachProfileSearchConfig
			? coachProfileSearchConfig
			: {
					languages: [],
					services: [],
					sportTypes: [],
					athleteTypes: [],
					genders: [],
					trainingPeaksCertifications: [],
					distanceUnits: [],
					coachMatchUrl: '',
					coachProfileSearchUri: ''
				};
	},

	getInitialState: function() {
		var config = this.getConfig();

		return {
			data: [],
			searchPerformed: false,
			isSearching: false,
			initialSearch: this.getInitialSearch(),
			searchParams: [],
			sportTypes: config.sportTypes,
			services: config.services,
			languages: config.languages,
			abilityLevels: config.athleteTypes,
			genders: config.genders,
			distanceUnits: config.distanceUnits,
			trainingPeaksCertifications: config.trainingPeaksCertifications,
			geocoder: new google.maps.Geocoder(),
			cachedGeocodedLocations: new Map(),
			coachMatchUrl: config.coachMatchUrl,
			coachProfileSearchUri: config.coachProfileSearchUri,
			maxSearchRequestId: 0
		};
	},

	getInitialSearch: function() {
		var searchParams = this.getCoachSearchUrlParams();

		var searchParamsAreEmpty =
			Object.keys(searchParams).length === 0 && JSON.stringify(searchParams) === JSON.stringify({});

		return searchParamsAreEmpty
			? {}
			: {
					keywords: searchParams[keywordsQsFieldName],
					location: searchParams[locationQsFieldName],
					lat: searchParams[latQsFieldName],
					lng: searchParams[lngQsFieldName],
					radius: searchParams[distanceQsFieldName],
					units: searchParams[distanceUnitsQsFieldName],
					sportTypes: searchParams[sportTypesQsFieldName],
					services: searchParams[servicesQsFieldName],
					languages: searchParams[languagesQsFieldName],
					abilityLevels: searchParams[abilityLevelsQsFieldName],
					genders: searchParams[gendersQsFieldName],
					trainingPeaksCertifications: searchParams[trainingPeaksCertificationsQsFieldName]
				};
	},

	getCoachSearchUrlParams: function() {
		var match,
			pl = /\+/g, // Regex for replacing addition symbol with a space
			search = /(cs_[^&=]+)=?([^&]*)/g,
			decode = function(s) {
				return decodeURIComponent(s.replace(pl, ' '));
			},
			query = window.location.search.substring(1),
			urlParams = {};

		while ((match = search.exec(query))) {
			urlParams[decode(match[1])] = decode(match[2]);
		}

		return urlParams;
	},

	buildHistoryUrl: function() {
		var searchParams = this.state.searchParams,
			historyUrl = window.location.origin + '/coaches/search',
			historyUrlParts = [];

		if (searchParams.keywords.length > 0) {
			historyUrlParts.push(`${keywordsQsFieldName}=${searchParams.keywords}`);
		}

		if (searchParams.location.length > 0) {
			historyUrlParts.push(`${locationQsFieldName}=${searchParams.location}`);
		}

		if (searchParams.location.length > 0 && searchParams.radius) {
			historyUrlParts.push(`${distanceQsFieldName}=${searchParams.radius}`);
		}

		if (searchParams.location.length > 0 && searchParams.lat) {
			historyUrlParts.push(`${latQsFieldName}=${searchParams.lat}`);
		}

		if (searchParams.location.length > 0 && searchParams.lng) {
			historyUrlParts.push(`${lngQsFieldName}=${searchParams.lng}`);
		}

		if (searchParams.location.length > 0 && searchParams.units.length > 0) {
			historyUrlParts.push(`${distanceUnitsQsFieldName}=${searchParams.units}`);
		}

		if (searchParams.sportTypes.length > 0) {
			historyUrlParts.push(`${sportTypesQsFieldName}=${searchParams.sportTypes}`);
		}

		if (searchParams.services.length > 0) {
			historyUrlParts.push(`${servicesQsFieldName}=${searchParams.services}`);
		}

		if (searchParams.languages.length > 0) {
			historyUrlParts.push(`${languagesQsFieldName}=${searchParams.languages}`);
		}

		if (searchParams.abilityLevels.length > 0) {
			historyUrlParts.push(`${abilityLevelsQsFieldName}=${searchParams.abilityLevels}`);
		}

		if (searchParams.genders.length > 0) {
			historyUrlParts.push(`${gendersQsFieldName}=${searchParams.genders.toLowerCase()}`);
		}

		if (searchParams.trainingPeaksCertifications.length > 0) {
			historyUrlParts.push(
				`${trainingPeaksCertificationsQsFieldName}=${searchParams.trainingPeaksCertifications}`
			);
		}

		if (historyUrlParts.length > 0) {
			return `${historyUrl}?${historyUrlParts.join('&')}`;
		}

		return historyUrl;
	},

	handleProfileView: function() {
		history.pushState({}, 'coach search', this.buildHistoryUrl());
	},

	_doSearch: function(params) {
		params.requestId = Date.now();
		this.setState({ isSearching: true });
		$.get({
			url: this.state.coachProfileSearchUri,
			data: params,
			dataType: 'json',
			success: function(data) {
				if (data.requestId > this.state.maxSearchRequestId) {
					this.setState({ data: data.hits, totalHits: data.totalHits }, function() {
						this.setState({
							searchPerformed: true,
							isSearching: false,
							maxSearchRequestId: data.requestId
						});
					});
				}
			}.bind(this),
			error: function(xhr, status, err) {
				if (Rollbar) {
					Rollbar.error('Failed to search coach directory', params, this.props.url, status, err);
				}
			}.bind(this),
			complete: function() {
				this.setState({ searchParams: params });
			}.bind(this)
		});
	},

	handleSearchSubmit: function(params) {
		if (params.location.length > 0 && !(params.lat && params.lng)) {
			var cachedResult = this.state.cachedGeocodedLocations.get(params.location);
			if (cachedResult) {
				params.lat = cachedResult.lat;
				params.lng = cachedResult.lng;
				this._doSearch(params);
				return;
			}

			var component = this;
			this.state.geocoder.geocode({ address: params.location }, function(results, status) {
				if (status === 'OK' && results.length > 0) {
					params.lat = results[0].geometry.location.lat();
					params.lng = results[0].geometry.location.lng();
					component.state.cachedGeocodedLocations.set(params.location, { lat: params.lat, lng: params.lng });
				}
				component._doSearch(params);
			});
		} else {
			this._doSearch(params);
		}
	},

	renderSearchResultMessage: function() {
		if (!this.state.searchPerformed || this.state.isSearching) {
			return;
		}

		return (
			<div>
				<SearchResultMessage
					term={this.state.searchTerm}
					numberOfResults={this.state.data.length}
					totalHits={this.state.totalHits}
					coachMatchUrl={this.state.coachMatchUrl}
				/>
			</div>
		);
	},

	renderLoading: function() {
		if (!this.state.isSearching) {
			return;
		}

		return (
			<div className="margin-top-30 margin-bottom-30">
				<img
					className="margin-right-10"
					src="data:image/gif;base64,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"
				/>
				Searching our coach database...
			</div>
		);
	},

	render: function() {
		return (
			<div className="advancedSearchComponent">
				<CoachSearchForm
					onSearchSubmit={this.handleSearchSubmit}
					sportTypeOptions={this.state.sportTypes}
					serviceOptions={this.state.services}
					languageOptions={this.state.languages}
					abilityLevelOptions={this.state.abilityLevels}
					genderOptions={this.state.genders}
					trainingPeaksCertificationOptions={this.state.trainingPeaksCertifications}
					distanceUnitOptions={this.state.distanceUnits}
					initialSearch={this.state.initialSearch}
				/>
				{this.renderLoading()}
				{this.renderSearchResultMessage()}
				<SearchResultsList
					data={this.state.data}
					searchPerformed={this.state.searchPerformed}
					onProfileView={this.handleProfileView}
				/>
			</div>
		);
	}
});

module.exports = CoachSearchComponent;
